import React from 'react';
import { TruckIcon, ClockIcon, RotateCcwIcon, InfinityIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
import { assurances, shippingNote } from '../data/product';
import { CtaButton } from './CtaButton';
const icons = {
  ship: TruckIcon,
  clock: ClockIcon,
  return: RotateCcwIcon,
  infinity: InfinityIcon
};
export function AssuranceSection() {
  return <section id="shipping" className="scroll-mt-28 border-b border-white/10 bg-ink-900" data-id="element-16" data-mp="2plnk025znutm">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-17" data-mp="2lmxx9iz290xb">
        <h2 className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-18" data-mp="2gls1tde0mzk3">
          Nothing to lose
          <br data-id="element-19" data-mp="157wpsdier6x3" />
          <span className="text-grit-500" data-id="element-20" data-mp="158fw0wyp46va">on this order.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-21" data-mp="155k0tge8fwaj">
          Ships fast from the U.S. Send it back inside 30 days if it&apos;s not for you. Break it later and we
          replace it free.
        </p>

        <ul className="mt-10 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-22" data-mp="anycs8lwaxjp">
          {assurances.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex h-full flex-col bg-ink-950 p-6" data-id="element-23" data-mp="1njmeuu2qs9c">
                <Icon className="h-8 w-8 text-grit-500" aria-hidden="true" data-id="element-24" data-mp="1pcxcmbpzyn5" />
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight text-offwhite" data-id="element-25" data-mp="3j2gmeerhil5f">
                  {item.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-steel-400" data-id="element-26" data-mp="3a44qpybrgx64">{item.body}</p>
              </li>;
        })}
        </ul>

        <div className="mt-8 grid gap-px border border-white/10 bg-white/10 lg:grid-cols-2" data-id="element-27" data-mp="3f0byzxrmqkr8">
          <div className="bg-ink-950 p-6 lg:p-7" data-id="element-28" data-mp="3078qsgzxhjd6">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-grit-500" data-id="element-29" data-mp="354ibjjcdh6uo">How it ships</p>
            <div className="mt-4" data-id="element-30" data-mp="2m0oyowrygtn1">
              <UspsBadge data-id="element-31" data-mp="2m0yexsn77mfj" />
            </div>
            <p className="mt-3 text-[15px] leading-relaxed text-steel-400" data-id="element-32" data-mp="2h8dngxrrllf6">{shippingNote}</p>
          </div>

          <div className="bg-ink-950 p-6 lg:p-7" data-id="element-33" data-mp="2c911sgcmqke6">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-grit-500" data-id="element-34" data-mp="2c7pz6jux7ion">Secure checkout</p>
            <div className="mt-4 flex items-center gap-3" data-id="element-35" data-mp="278wjqlw2phlu">
              <LockIcon className="h-6 w-6 shrink-0 text-offwhite" aria-hidden="true" data-id="element-36" data-mp="34x6ov9r5olh6" />
              <p className="font-display text-xl font-bold uppercase leading-tight tracking-wide text-offwhite" data-id="element-37" data-mp="300g9kon6dtwt">
                256-bit SSL encrypted payment
              </p>
            </div>
            <p className="mt-3 text-[15px] leading-relaxed text-steel-400" data-id="element-38" data-mp="2q076qryoha8g">
              Your card details are encrypted end to end and processed by our PCI DSS compliant payment provider. We
              never see or store your card number.
            </p>
            <div className="mt-5" data-id="element-39" data-mp="3q9fb0x8280a3">
              <PaymentLogos data-id="element-40" data-mp="3qa6y1jnlcpor" />
            </div>
            <ul className="mt-5 grid gap-2 border-t border-white/10 pt-4 sm:grid-cols-2" data-id="element-41" data-mp="3q7cctpwr70ua">
              {['Verified by Visa and Mastercard SecureCode', 'Fraud protection on every order', 'No card details stored on our servers', 'Full refund inside 30 days'].map(line => <li key={line} className="flex items-start gap-2 text-[13px] font-medium text-steel-300" data-id="element-42" data-mp="dqyz67humlr3">
                  <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grit-500" aria-hidden="true" data-id="element-43" data-mp="hsapygcgld0v" />
                  {line}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 flex justify-start" data-id="element-44" data-mp="rr9rleyt48ed">
          <CtaButton className="w-full sm:w-auto" data-id="element-45" data-mp="2okblvr2no1r5">Get your X1 risk free</CtaButton>
        </div>
      </div>
    </section>;
}